<div class="row">
    <div class="col-12 pl-4">
        <yt-fw-default-update-buttons #defaultUpdateButtons>
            <div class="btn-group mr-2">
                <button [disabled]="baseUpdate.Item.ID==-1 || !hasUserRightsUvozIzvoda!" class="btn btn-outline-primary" type="button" id="btnUvozIzvoda"
                    (click)="UvozIzvoda()"
                    ngbTooltip="{{'IZVOD.UVOZIZVODA.ACTION' | translate }}"  container="body" [disabled]="!baseUpdate.Item.Editable">
                    <i class="fas fa-file-import control-label"></i>
                    <span style="padding-left: 5px;" translate="IZVOD.UVOZIZVODA.SINGULAR"></span>
                    <!-- Uvoz izvoda -->
                </button>
            </div>
            <div class="mr-2" *ngIf="loading">
                <span  class="loader"><span class="fa fa-spinner fa-spin"></span></span>
            </div>
            <div class="mr-2">
                    <h2 style="display:inline-block; color: #71b1d1">
                        <span *ngIf="baseUpdate.Item.ID <= 0"><span translate="IZVOD.NEW"></span></span>
                        <span *ngIf="baseUpdate.Item.ID > 0">
                            <span translate="IZVOD.BROJDOKUMENTA.SINGULAR"></span>
                            <span style="padding-left: 5px">{{baseUpdate.Item.BrojDokumenta}}</span>
                        </span>
                    </h2>
                </div>
        </yt-fw-default-update-buttons>

      </div>
  </div>
  <yt-izvod-update #baseUpdate></yt-izvod-update>